type TimeUnit = 'minutes' | 'hours' | 'days' | 'weeks'

const MINUTE_MS = 60 * 1000
const HOUR_MS = 60 * MINUTE_MS
const DAY_MS = 24 * HOUR_MS
const WEEK_MS = 7 * DAY_MS

const UNIT_MS = Object.freeze({
  minutes: MINUTE_MS,
  hours: HOUR_MS,
  days: DAY_MS,
  weeks: WEEK_MS
})

const addTime = (amount: number, unit: TimeUnit): Date => {
  if (!Number.isFinite(amount) || amount < 0) throw new Error('Amount must be a valid non-negative number')

  return new Date(Date.now() + amount * UNIT_MS[unit])
}

export const useCookieExpire = {
  minutes(amount: number): Date {
    return addTime(amount, 'minutes')
  },
  hours(amount: number): Date {
    return addTime(amount, 'hours')
  },
  days(amount: number): Date {
    return addTime(amount, 'days')
  },
  weeks(amount: number): Date {
    return addTime(amount, 'weeks')
  }
}
